import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1100px;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: #3e3d3f;
  background: transparent;
  @media (max-width: 1366px) {
    font-size: 14px;
  }
`;
